// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NdShM","left":"styles_left__OQIRU","right":"styles_right__++Rwz","centered":"styles_centered__sfP+-"};